var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-4 py-3 rounded-full border border-gray-300 mr-1 mb-2 focus:outline-none text-xs",class:_vm.value ? 'bg-azuloscuro text-white' : 'bg-white text-azuloscuro',on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.category))])}
var staticRenderFns = []

export { render, staticRenderFns }